import * as React from "react";
import { OrganizationKeyName } from "../../model/Organization";
import { Link } from "react-router-dom";
import { routes } from "../../appRoutingHelpers";
import { TestIdsEnum } from "../../TestIdsEnum";
import { UserTermListItem } from "../../service/api-response/UserTermListSuccessResponse";

interface Props {
  organization: OrganizationKeyName;
  userTerm: UserTermListItem;
}

const UserTermListRow: React.FC<Props> = (props) => {
  const userTerm = props.userTerm;
  const org = props.organization;

  return (
    <tr>
      <td>
        <Link to={routes.userTermEdit(org, userTerm.id)}>{userTerm.title}</Link>
      </td>
      <td>{userTerm.createdAt}</td>
      <td>{userTerm.keyName}</td>
      <td>{userTerm.description}</td>
      <td>
        <Link
          to={routes.userTermEdit(org, userTerm.id)}
          className="btn btn-sm btn-primary"
          data-test={TestIdsEnum.UserTermRowEditButton}
        >
          Edit
        </Link>
        <Link
          to={routes.userTermVersionList(org, userTerm.id)}
          className="btn btn-sm btn-secondary"
          data-test={TestIdsEnum.UserTermRowEditButton}
        >
          Versions
        </Link>
      </td>
    </tr>
  );
};

export default UserTermListRow;
